import { useState } from "react";

import Lightbox from "../../common/Lightbox";

import useCurrentUser from "../../../hooks/useCurrentUser";
import useRouting from "../../../hooks/useRouting";
import { IProject } from "../../../data_models/project";
import useProjects from "../../../hooks/useProjects";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";


interface VerifyRoadmapLightboxProps {
    projectId: string;
    onClose: () => void;
    onUpdateProject: (project: IProject) => void;
    afterConfirmAction: () => void;
}

const VerifyRoadmapLightbox: React.FC<VerifyRoadmapLightboxProps> = ({ projectId, onClose, onUpdateProject, afterConfirmAction }) => {


    const [loading, setLoading] = useState(false);

    const { locallyUpdateCurrentUserWallet } = useCurrentUser();
    const { goToPricing } = useRouting();
    const { verifyProjectRoadmap } = useProjects();
    const { addErrorNotification } = useDisplayNotifications();


    const onVerifyRoadmap = async () => {
        try {
            setLoading(true);
            const result = await verifyProjectRoadmap(projectId);
            onUpdateProject(result.project);
            locallyUpdateCurrentUserWallet(result.wallet);
            afterConfirmAction();
        } catch (error: any) {
            addErrorNotification(error.message, "Verify Roadmap Failed");
        } finally {
            setLoading(false);
            onClose();
        }
    }

    return (
        <Lightbox
            header="Verify the Roadmap"
            content={
                <div className="flex flex-col items-start space-y-3" >
                    <p>Make sure the project description and task breakdown is clear, doable, and realistic based on the effort. And the most important: it must meet the expecations of the client. To clarify everything please also get in touch with the client.</p>
                    <ul>
                        <li>Are the project details easy to understand?</li>
                        <li>Any ambiguities to clear up?</li>
                        <li>Is the effort for each task realistic?</li>
                        <li>Are the tasks and definitions of done clear?</li>
                        <li>Will this roadmap deliver what the client expects?</li>
                    </ul>
                </div>}
            confirmText="Verify Roadmap"
            onConfirm={onVerifyRoadmap}
            loadingConfirm={loading}
            onCancel={onClose}
            onClose={onClose}

        />

    );
}

export default VerifyRoadmapLightbox;
